import { DocumentDesigner } from '../../../components/document-designer/document-designer';
import { useEnablePickListHtmlEditor } from '../../../feature-flags/hooks/use-enable-pick-list-html-editor';
import { PickListHtmlTemplatePage } from './pick-list-html-template-page';

export const PickListTemplatePage = () => {
  const isHtmlEditorEnabled = useEnablePickListHtmlEditor();

  if (!isHtmlEditorEnabled) {
    return <DocumentDesigner documentSize='8.5"x11"' documentType='pickList' />;
  }

  return <PickListHtmlTemplatePage />;
};
